import React, { useState } from 'react';
import { translate } from 'react-i18next';
import Modal from 'react-modal';
import { similarQuestionsFetch } from '../../../actions/index';
import { Icon } from '../Icon';
import cx from '../../../styles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';


const SimilarQuestions = (props) => {
    const [questionsData, setQuestionsData] = useState([])
    const [noQuestionsFound, setNoQuestionsFound] = useState(false);
    const { t } = props;
    const afterOpenSimilarQuestion = () => {
        props.setLoading(true)
        props.similarQuestionsFetch(1, props.title, props.content)
            .then((response) => {
                if (response.data.length) {
                    setQuestionsData([...response.data])
                    props.setLoading(false)
                } else {
                    setNoQuestionsFound(true)
                    props.setLoading(false)
                }
            })
            .catch((err) => {
                props.setLoading(false)
                setNoQuestionsFound(true)
                console.log(err)
            })
    }
    const resetState = () => {
        setNoQuestionsFound(false)
        setQuestionsData([])
    }
    return (
        <Modal
            isOpen={props.showSimilarQues}
            onRequestClose={() => { props.toggleSimilarScreen(); resetState(); }}
            onAfterOpen={afterOpenSimilarQuestion}
            overlayClassName={"similar-questions-modal"}
        >
            <div className={cx("header")}>
                <span className={cx("close-modal")} onClick={() => { props.toggleSimilarScreen(); resetState(); }}>
                    <Icon name="cross-regular-dark-smd" />
                </span>
                <div className={cx('text')}>{t('similar_question')}</div>
            </div>
            {
                !noQuestionsFound && <p className={cx('security-alert')}>{t('alert_message')}</p>
            }
            <div className={cx('divider')} />

            {
                !noQuestionsFound && questionsData && questionsData.length ?
                    questionsData.map((res, key) => {
                        return (
                            <div className={cx('questions-wrap')} key={key}>
                                <a href={res.url} target="_blank" className={cx('title')}>{res.title}</a>
                                <div className={cx('bottom-wrap')}>
                                    <p className={cx('reply-count')}>{res.reply_count} {t('detail_reply_count_plural')}</p>
                                    {
                                        res.most_relevant === '1' &&
                                        <div className={cx('most-relevant')}>
                                            <Icon name="most-relevant-regular" />
                                            <p className={cx('text')}>  {t('most_relevant')}</p>
                                        </div>
                                    }
                                </div>
                            </div>
                        )
                    })
                    :
                    noQuestionsFound &&
                    <div className={cx('no-question-found')}>
                        <div>
                            <Icon name="no-similar-question-found-regular" />
                            <p>{t('no_similar_questions_found')}</p>
                        </div>
                    </div>
            }
        </Modal>
    );
}

//map state
const mapStateToProps = (state) => state;

//map dispatch
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        similarQuestionsFetch
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(translate()(SimilarQuestions));
